
export default function (element, data) {
    element.querySelectorAll(".switch-tab").forEach((button) => button.addEventListener("click", (event) => {
        var contentSelector = button.dataset.switchContentSelector;
        var displayMode = button.dataset.switchDisplayMode || "block";

        element.querySelectorAll(".switch-tab").forEach((button) => button.classList.remove("current"));
        button.classList.add("current");
        
        element.querySelectorAll(".switch-content").forEach((content) => content.style.display = 'none');
        element.querySelectorAll(contentSelector).forEach((content) => content.style.display = displayMode);
    }));

    const firstButton = element.querySelector(".switch-tab");

    if(firstButton)
    {
        const contentSelector = firstButton.dataset.switchContentSelector;
        const displayMode = firstButton.dataset.switchDisplayMode || "block";
    
        firstButton.classList.add("current");
        
        element.querySelectorAll(".switch-content").forEach((content) => content.style.display = 'none');
        element.querySelectorAll(contentSelector).forEach((content) => content.style.display = displayMode);
    }

}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary